import React from "react";
import "./InformationGeneral.scss"
import DraftTextareaEditor from "../../../../components/editor/DraftTextareaEditor";


const InformationGeneral = ({
        title = "",
        contentRaw = {},
        kind = "gallery",
        handleCurrentMedia = ()=>{}
    }) => {

    return (
        <div id={"information-general"}>
            {kind === "video" ? <div className={"information-general-info"}>ASTUCE : Une fois votre vidéo encodée, vous pouvez modifier sa vignette en allant l'éditer.</div> : null }
            <div className={"information-general-form"}>
                <input type={"text"} className={title.trim().length === 0 ? 'error' : ''}
                       placeholder={"(Titre obligatoire)"} name={"title"}
                       value={title}
                       onBlur={()=>handleCurrentMedia("title", title.trim())}
                       onChange={(event) => handleCurrentMedia("title", event.target.value)} required/>
                {title.length === 0 ?<div className={"error-text"}>Choisissez un titre qui décrit votre média.</div> : null}
                <DraftTextareaEditor
                    defaultValue={contentRaw}
                    placeholder={"Description"}
                    onChange={(contentRawUpdate) => handleCurrentMedia("contentRaw", contentRawUpdate)}
                />
            </div>

        </div>
    )
}

export default InformationGeneral;